import { getPublication } from '../api/api';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PDFViewer2 from '../components/PDFViewer2';
import { useLocation } from 'react-router-dom';

function PublicationDetail() {

  const [publication, setPublication] = useState();
  const [fileUrl, setFileUrl] = useState();
  const [iframeCode, setIframeCode] = useState();

  const location = useLocation();
  const regex = /^\/magazine\/[a-f0-9-]+\/publication\/[a-f0-9-]+\/fullscreen$/;
  const isFullScreen = regex.test(location.pathname);

  const { magazineId, publicationId } = useParams();

  useEffect(() => {
    getPublication(magazineId, publicationId).then((data) => {
      setPublication(data);
    }).catch((error) => {
      console.log(error);
    });
  }, [magazineId, publicationId]);

  useEffect(() => {
    setFileUrl(publication && `${process.env.REACT_APP_MEDIA_HOSTNAME}/${magazineId}/${publication.id}/magazine.pdf`);
    //setFileUrl(publication && `/39.pdf`);
  }, [publication])

  useEffect(() => {
    setIframeCode(`<iframe src="${window.location.href.replaceAll('#', '')}/fullscreen" width="800" height="500" allowfullscreen="true" style="border:0"></iframe>`);
  }, [])

  const handleIframeCodeFocus = (event) => {
    event.preventDefault();
    // Select all
    event.target.select();
  }

  return (
    <div className={!isFullScreen ? 'p-4' : 'fullscreenViewerContainer'}>
      {publication && (
        <>
          {!isFullScreen && (
            <>
              <a href={`/magazine/${magazineId}`}>Ver más publicaciones de la revista</a>
              <h1>{publication.name}</h1>
              <p>{publication.description}</p>
            </>
          )}
          {
            publication.pdfUploaded && fileUrl ? (
              <>
                <PDFViewer2 url={fileUrl} />
              </>
            ) : (
              <p>PDF no subido</p>
            )
          }
          {publication.pdfUploaded && fileUrl && !isFullScreen && (
            <>
            <h4 style={{paddingTop: '1em'}}>Código para insertar en un iframe</h4>
            <textarea style={{width: '100%'}} width="500" onFocus={handleIframeCodeFocus}>
              {iframeCode}
            </textarea>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default PublicationDetail;
